export default __webpack_public_path__ + "static/media/skoda-then.4377c688.svg";